/* Tempo Reviews widget — vanilla JS, no dependencies.
   Data: tempo-reviews.json (deduplicated from Tempo Seed Reviews.xlsx).
   The JSON's array order IS the "Featured" sort. */
(function () {
  'use strict';

  var STAR = '<svg viewBox="0 0 13 13" aria-hidden="true"><path d="M6.14185 10.1419C6.28088 10.0579 6.45496 10.0579 6.59399 10.1419L9.80623 12.0806C10.1376 12.2806 10.5463 11.9836 10.4584 11.6067L9.60591 7.95257C9.56902 7.79442 9.62276 7.62884 9.74551 7.5225L12.5842 5.06336C12.8767 4.80995 12.7203 4.32946 12.3347 4.29675L8.5978 3.97971C8.43611 3.96599 8.29529 3.86391 8.23197 3.7145L6.77073 0.266818C6.61998 -0.088882 6.11586 -0.0888818 5.96511 0.266818L4.50387 3.7145C4.44055 3.86391 4.29973 3.96599 4.13804 3.97971L0.401132 4.29675C0.0155087 4.32946 -0.140857 4.80995 0.151655 5.06336L2.99033 7.5225C3.11308 7.62884 3.16682 7.79442 3.12993 7.95257L2.27748 11.6067C2.18956 11.9836 2.59828 12.2806 2.92961 12.0806L6.14185 10.1419Z"/></svg>';
  var CHECK = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M7 0C3.15 0 0 3.15 0 7C0 10.85 3.15 14 7 14C10.85 14 14 10.85 14 7C14 3.15 10.85 0 7 0ZM6.125 9.975L3.15 7L4.375 5.775L6.125 7.525L9.625 4.025L10.85 5.25L6.125 9.975Z"/></svg>';
  var REPLY_COLLAPSE_AT = 200;

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function stars(n, cls) {
    var out = '<span class="tr-stars ' + (cls || '') + '" role="img" aria-label="Rated ' + n + ' out of 5 stars">';
    for (var i = 1; i <= 5; i++) {
      out += '<span class="tr-star' + (i <= n ? ' is-filled' : '') + '">' + STAR + '</span>';
    }
    return out + '</span>';
  }

  function relDate(iso) {
    var then = new Date(iso + 'T12:00:00');
    var days = Math.max(0, Math.round((Date.now() - then.getTime()) / 86400000));
    if (days <= 1) return 'today';
    if (days < 7) return days + ' days ago';
    if (days < 14) return '1 week ago';
    if (days < 31) return Math.round(days / 7) + ' weeks ago';
    if (days < 61) return '1 month ago';
    return Math.round(days / 30.4) + ' months ago';
  }

  var TempoReviews = function (el) {
    this.el = el;
    this.perPage = parseInt(el.dataset.perPage, 10) || 10;
    this.state = { sort: 'featured', ratings: {}, topic: null, shown: this.perPage };
    this.refs = {
      summary: el.querySelector('[js-tr-summary]'),
      histogram: el.querySelector('[js-tr-histogram]'),
      chips: el.querySelector('[js-tr-chips]'),
      count: el.querySelector('[js-tr-count]'),
      sort: el.querySelector('[js-tr-sort]'),
      list: el.querySelector('[js-tr-list]'),
      more: el.querySelector('[js-tr-more]'),
    };
    this.load();
  };

  TempoReviews.prototype.load = function () {
    var self = this;
    fetch(this.el.dataset.src)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        self.data = data;
        self.renderStatic();
        self.bind();
        self.update();
        if (self.el.dataset.jsonld === 'true') self.injectJsonLd();
      })
      .catch(function () {
        self.refs.summary.innerHTML = '<p>Reviews are temporarily unavailable.</p>';
      });
  };

  TempoReviews.prototype.renderStatic = function () {
    var m = this.data.meta;
    var pct = (m.average / 5) * 100;
    this.refs.summary.innerHTML =
      '<div class="tr-summary__score">' + m.average.toFixed(1) + '</div>' +
      '<div class="tr-summary__stars" role="img" aria-label="Rated ' + m.average + ' out of 5 stars">' +
        '<span class="tr-stars tr-stars--base">' + STAR + STAR + STAR + STAR + STAR + '</span>' +
        '<span class="tr-stars tr-stars--fill" style="width:' + pct + '%">' + STAR + STAR + STAR + STAR + STAR + '</span>' +
      '</div>' +
      '<p class="tr-summary__count">Based on ' + m.count + ' reviews</p>';

    var maxCount = 0, r;
    for (r = 5; r >= 1; r--) maxCount = Math.max(maxCount, m.histogram[r] || 0);
    var bars = '';
    for (r = 5; r >= 1; r--) {
      var c = m.histogram[r] || 0;
      var w = maxCount ? Math.max(c / maxCount * 100, c ? 2 : 0) : 0;
      bars +=
        '<button type="button" class="tr-bar" data-rating="' + r + '" aria-pressed="false"' +
        ' aria-label="Show ' + c + ' reviews rated ' + r + ' stars"' + (c ? '' : ' disabled') + '>' +
          '<span class="tr-bar__label">' + r + '<span class="tr-star is-filled">' + STAR + '</span></span>' +
          '<span class="tr-bar__track"><span class="tr-bar__fill" style="width:' + w + '%"></span></span>' +
          '<span class="tr-bar__count">' + c + '</span>' +
        '</button>';
    }
    this.refs.histogram.innerHTML = bars;

    var chips = '';
    (this.data.meta.topics || []).forEach(function (t) {
      chips += '<button type="button" class="tr-chip" data-topic="' + esc(t) + '" aria-pressed="false">' + esc(t) + '</button>';
    });
    this.refs.chips.innerHTML = chips;
  };

  TempoReviews.prototype.bind = function () {
    var self = this;
    this.refs.histogram.addEventListener('click', function (e) {
      var btn = e.target.closest('.tr-bar');
      if (!btn) return;
      var r = btn.dataset.rating;
      self.state.ratings[r] = !self.state.ratings[r];
      btn.setAttribute('aria-pressed', self.state.ratings[r] ? 'true' : 'false');
      btn.classList.toggle('is-active', self.state.ratings[r]);
      self.state.shown = self.perPage;
      self.update();
    });
    this.refs.chips.addEventListener('click', function (e) {
      var btn = e.target.closest('.tr-chip');
      if (!btn) return;
      var t = btn.dataset.topic;
      self.state.topic = self.state.topic === t ? null : t;
      self.refs.chips.querySelectorAll('.tr-chip').forEach(function (b) {
        var on = b.dataset.topic === self.state.topic;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      self.state.shown = self.perPage;
      self.update();
    });
    this.refs.sort.addEventListener('change', function () {
      self.state.sort = self.refs.sort.value;
      self.state.shown = self.perPage;
      self.update();
    });
    this.refs.more.addEventListener('click', function () {
      self.state.shown += self.perPage;
      self.update(true);
    });
    this.refs.list.addEventListener('click', function (e) {
      var t = e.target.closest('.tr-reply__toggle');
      if (!t) return;
      var reply = t.closest('.tr-reply');
      var expanded = reply.classList.toggle('is-expanded');
      t.textContent = expanded ? 'Read less' : 'Read more';
      t.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  };

  TempoReviews.prototype.filtered = function () {
    var st = this.state;
    var anyRating = Object.keys(st.ratings).some(function (k) { return st.ratings[k]; });
    var list = this.data.reviews.filter(function (rv) {
      if (anyRating && !st.ratings[rv.rating]) return false;
      if (st.topic && rv.topics.indexOf(st.topic) === -1) return false;
      return true;
    });
    if (st.sort === 'recent') list = list.slice().sort(function (a, b) { return b.date < a.date ? -1 : b.date > a.date ? 1 : 0; });
    else if (st.sort === 'oldest') list = list.slice().sort(function (a, b) { return a.date < b.date ? -1 : a.date > b.date ? 1 : 0; });
    else if (st.sort === 'highest') list = list.slice().sort(function (a, b) { return b.rating - a.rating; });
    else if (st.sort === 'lowest') list = list.slice().sort(function (a, b) { return a.rating - b.rating; });
    return list;
  };

  TempoReviews.prototype.card = function (rv) {
    var av = ['tr-av--terracotta', 'tr-av--sage', 'tr-av--rust'][rv.avatar] || 'tr-av--terracotta';
    var html =
      '<li class="tr-card">' +
        '<div class="tr-card__identity">' +
          '<span class="tr-av ' + av + '" aria-hidden="true">' + esc(rv.initials) + '</span>' +
          '<div class="tr-card__who">' +
            '<p class="tr-card__name">' + esc(rv.name) + '</p>' +
            (rv.verified ? '<p class="tr-card__verified">' + CHECK + 'Verified Buyer</p>' : '') +
          '</div>' +
        '</div>' +
        '<div class="tr-card__content">' +
          '<div class="tr-card__meta">' + stars(rv.rating) +
            '<span class="tr-card__date">' + relDate(rv.date) + '</span>' +
          '</div>' +
          '<h3 class="tr-card__title">' + esc(rv.title) + '</h3>' +
          '<p class="tr-card__body">' + esc(rv.body) + '</p>';
    if (rv.reply) {
      var long = rv.reply.body.length > REPLY_COLLAPSE_AT;
      html +=
        '<div class="tr-reply' + (long ? '' : ' is-expanded') + '">' +
          '<div class="tr-reply__head"><span class="tr-reply__brand">Tempo</span>' +
          '<span class="tr-card__date">' + relDate(rv.reply.date) + '</span></div>' +
          '<p class="tr-reply__body">' + esc(rv.reply.body) + '</p>' +
          (long ? '<button type="button" class="tr-reply__toggle" aria-expanded="false">Read more</button>' : '') +
        '</div>';
    }
    html += '</div></li>';
    return html;
  };

  TempoReviews.prototype.update = function (append) {
    var list = this.filtered();
    var visible = list.slice(0, this.state.shown);
    var self = this;
    this.refs.list.innerHTML = visible.map(function (rv) { return self.card(rv); }).join('');
    this.refs.count.textContent = list.length + (list.length === 1 ? ' review' : ' reviews');
    this.refs.more.hidden = visible.length >= list.length;
    if (append) {
      var items = this.refs.list.querySelectorAll('.tr-card');
      var target = items[Math.max(0, visible.length - this.perPage)];
      if (target) target.querySelector('.tr-card__title').setAttribute('tabindex', '-1');
    }
  };

  TempoReviews.prototype.injectJsonLd = function () {
    var m = this.data.meta;
    var s = document.createElement('script');
    s.type = 'application/ld+json';
    s.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: this.el.dataset.productName || 'Tempo Fiber Gummies',
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: m.average,
        reviewCount: m.count,
        bestRating: 5,
        worstRating: 1,
      },
    });
    document.head.appendChild(s);
  };

  function init() {
    document.querySelectorAll('tempo-reviews').forEach(function (el) {
      if (el.__trInit) return;
      var start = function () { el.__trInit = true; new TempoReviews(el); };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { io.disconnect(); start(); }
          });
        }, { rootMargin: '800px 0px' });
        io.observe(el);
      } else {
        start();
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
